import React, { useState } from "react";
import image from "../assets/image.png";

const Form = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [alert, setAlert] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert(null);

    if (!email || !password) {
      setAlert("Please fill in all fields");
      return;
    }
    try {
      setIsloading(true);
      const response = await fetch("https://api.appispace.com/users/delete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
      if (response.ok) {
        setIsDeleted(true);
        setIsloading(false);
        setAlert("Account deleted");
      } else {
        setIsDeleted(false);
        setAlert("Error deleting account, please try again.");
        setIsloading(false);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  return (
    <div className="form-container">
      <form
        className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 justify-center form"
        onSubmit={handleSubmit}
      >
        {!isLoading && !isDeleted && (
          <div className="flex flex-col">
            <img src={image} alt="Appisce" className="image self-center" />

            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="email"
              >
                Email
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email"
                type="text"
                value={email}
                placeholder="Email"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setAlert(false);
                }}
              />
            </div>
            <div className="mb-6">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="password"
              >
                Password
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="password"
                type="password"
                value={password}
                autoComplete="off"
                placeholder="Password"
                onChange={(e) => {
                  setPassword(e.target.value);
                  setAlert(false);
                }}
              />
            </div>
            <div className="flex flex-col">
              <button
                className="bg-[#505450] hover:bg-[#2E312E] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline self-stretch"
                type="Delete my account"
              >
                Delete my account
              </button>
            </div>
            <div className="text-center mt-5">
              {alert && <p className="text-red-500 text-l italic">{alert}</p>}
            </div>
          </div>
        )}
        <div className="text-center">
          {isLoading && "Deleting..."}
          {!isLoading && isDeleted && "Your account was deleted successfully."}
        </div>
      </form>

      <p className="text-center text-gray-500 text-xs">
        &copy; Copyright Appispace 2024 - All Rights Reserved
      </p>
    </div>
  );
};

export default Form;
